/* ============================================================
   MORNING FIX COFFEE
   BUILD #2 — LANDING PAGE ROUTING
   ============================================================

   RESPONSIBILITY
   ------------------------------------------------------------
   Converts Build #1 roast results into landing-page
   configuration.

   Build #2 DOES NOT:
   • calculate scores
   • modify the profile
   • determine roast results
   • manipulate the quiz engine
   • add products to cart

   Shopify product/variant IDs are intentionally kept in
   configuration and will be populated when the actual
   Shopify products are wired in.
   ============================================================ */


const CoffeeLandingPages = (function () {


  /* ==========================================================
     1. LANDING PAGE CONFIGURATION
     ========================================================== */

  const LANDING_PAGES = {

    1: {
      id: 1,
      resultId: "R1",
      name: "Medium-Light Roast",
      type: "single",

      products: [
        {
          key: "medium_light",
          name: "Medium-Light Roast"
        }
      ]
    },


    2: {
      id: 2,
      resultId: "R2",
      name: "Medium-Light → Medium",
      type: "transition",

      products: [
        {
          key: "medium_light",
          name: "Medium-Light Roast"
        },
        {
          key: "medium",
          name: "Medium Roast"
        }
      ],

      bothOption: true
    },


    3: {
      id: 3,
      resultId: "R3",
      name: "Medium Roast",
      type: "single",

      products: [
        {
          key: "medium",
          name: "Medium Roast"
        }
      ]
    },


    4: {
      id: 4,
      resultId: "R4",
      name: "Medium → Medium-Dark",
      type: "transition",

      products: [
        {
          key: "medium",
          name: "Medium Roast"
        },
        {
          key: "medium_dark",
          name: "Medium-Dark Roast"
        }
      ],

      bothOption: true
    },


    5: {
      id: 5,
      resultId: "R5",
      name: "Medium-Dark Roast",
      type: "single",

      products: [
        {
          key: "medium_dark",
          name: "Medium-Dark Roast"
        }
      ]
    },


    6: {
      id: 6,
      resultId: "R6",
      name: "Medium-Dark → Dark",
      type: "transition",

      products: [
        {
          key: "medium_dark",
          name: "Medium-Dark Roast"
        },
        {
          key: "dark",
          name: "Dark Roast"
        }
      ],

      bothOption: true
    },


    7: {
      id: 7,
      resultId: "R7",
      name: "Dark Roast",
      type: "single",

      products: [
        {
          key: "dark",
          name: "Dark Roast"
        }
      ]
    }

  };


  /* ==========================================================
     2. RESULT → LANDING PAGE MAP
     ========================================================== */

  const RESULT_TO_PAGE = {

    R1: 1,
    R2: 2,
    R3: 3,
    R4: 4,
    R5: 5,
    R6: 6,
    R7: 7

  };


  /* ==========================================================
     3. GET LANDING PAGE
     ========================================================== */

  function getLandingPage(pageNumber) {

    const page =
      LANDING_PAGES[pageNumber];

    if (!page) {

      throw new Error(
        "Landing page not found: " +
        pageNumber
      );

    }

    return page;

  }


  /* ==========================================================
     4. GET PAGE FROM RESULT
     ========================================================== */

  function getPageForResult(resultId) {

    const pageNumber =
      RESULT_TO_PAGE[resultId];

    if (!pageNumber) {

      throw new Error(
        "No landing page mapped for result: " +
        resultId
      );

    }

    return getLandingPage(
      pageNumber
    );

  }


  /* ==========================================================
     5. GET PAGE FROM PROFILE
     ========================================================== */

  function getPageForProfile(profile) {

    if (!profile) {

      throw new Error(
        "Profile is required."
      );

    }


    if (!profile.roastResult) {

      throw new Error(
        "Profile does not contain a roast result."
      );

    }


    return getPageForResult(
      profile.roastResult.id
    );

  }


  /* ==========================================================
     6. GET PURCHASE OPTIONS
     ========================================================== */

  function getPurchaseOptions(pageNumber) {

    const page =
      getLandingPage(
        pageNumber
      );


    const options =
      page.products.map(function(product) {

        return {

          key: product.key,

          name: product.name,

          type: "single"

        };

      });


    if (page.bothOption) {

      options.push({

        key: "both",

        name: "Buy Both",

        type: "both",

        products:
          page.products.map(function(product) {

            return product.key;

          })

      });

    }


    return options;

  }


  /* ==========================================================
     7. BUILD LANDING PAGE RESULT
     ========================================================== */

  function buildResult(profile) {

    const page =
      getPageForProfile(
        profile
      );


    return {

      resultId:
        profile.roastResult.id,

      resultName:
        profile.roastResult.name,

      landingPage:
        page.id,

      landingPageName:
        page.name,

      landingPageType:
        page.type,

      purchaseOptions:
        getPurchaseOptions(
          page.id
        )

    };

  }


  /* ==========================================================
     8. VALIDATE ROUTING
     ========================================================== */

  function validate() {

    const resultIds =
      Object.keys(
        RESULT_TO_PAGE
      );


    if (resultIds.length !== 7) {

      throw new Error(
        "Build #2 must contain exactly 7 result mappings."
      );

    }


    resultIds.forEach(function(resultId) {

      const pageNumber =
        RESULT_TO_PAGE[resultId];

      const page =
        LANDING_PAGES[pageNumber];


      if (!page) {

        throw new Error(
          "Missing landing page for " +
          resultId
        );

      }


      if (
        page.resultId !== resultId
      ) {

        throw new Error(
          "Result/page mismatch: " +
          resultId
        );

      }


      if (
        page.type === "transition" &&
        page.bothOption !== true
      ) {

        throw new Error(
          "Transition page " +
          pageNumber +
          " must have a Both option."
        );

      }


      if (
        page.type === "single" &&
        page.products.length !== 1
      ) {

        throw new Error(
          "Single-result page " +
          pageNumber +
          " must contain exactly one product."
        );

      }


      if (
        page.type === "transition" &&
        page.products.length !== 2
      ) {

        throw new Error(
          "Transition page " +
          pageNumber +
          " must contain exactly two products."
        );

      }

    });


    return {

      valid: true,

      landingPages: 7,

      transitionPages: 3,

      singlePages: 4

    };

  }


  /* ==========================================================
     9. PUBLIC API
     ========================================================== */

  return {

    version: "1.0.0",

    build: 2,

    getLandingPage,

    getPageForResult,

    getPageForProfile,

    getPurchaseOptions,

    buildResult,

    validate

  };

})();


/* ============================================================
   10. INITIAL VALIDATION
   ============================================================ */

CoffeeLandingPages.validate();


/* ============================================================
   11. GLOBAL EXPORT
   ============================================================ */

if (
  typeof window !== "undefined"
) {

  window.CoffeeLandingPages =
    CoffeeLandingPages;

}


/* ============================================================
   END BUILD #2
   ============================================================ */